import { Button, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/useAuth"; // ✅ correct import

/**
 * LogoutButton.jsx
 * Signs out the user and redirects to login.
 * Hydration-safe and scoped to authenticated session.
 */
export default function LogoutButton() {
  const { logout, loading } = useAuth() || {};
  const navigate = useNavigate();
  const toast = useToast();

  // Don’t render until auth context is hydrated
  if (loading || !logout) return null;

  const handleLogout = async () => {
    try {
      await logout();
      toast({
        title: "Logged out",
        description: "You have been signed out successfully.",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Logout failed:", error);
      toast({
        title: "Logout failed",
        description: error.message || "Unexpected error during sign out.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return (
    <Button
      variant="outline"
      colorScheme="red"
      size="sm"
      onClick={handleLogout}
    >
      🚪 Logout
    </Button>
  );
}
